import { Component, OnInit, Input, SimpleChange, SimpleChanges, OnChanges } from '@angular/core';
import { Sale } from 'src/app/models/Sale';
import { SaleService } from 'src/app/services/partner/sale.service';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-sale-skladisce-table',
  templateUrl: './sale-skladisce-table.component.html',
  styleUrls: ['./sale-skladisce-table.component.css']
})
export class SaleSkladisceTableComponent implements OnInit, OnChanges {
  public dateList: Array<string> = [];
  @Input() saleType;
  public displayedColumns: string[];
  public countryList: Array<string> = [];
  public tableByCountries: Array<Array<Array<Sale>>> = [[]];
  @Input() saleFilter;
  @Input() dataList;
  @Input() dataIndex;
  @Input() twoColumns;
  public shouldBeExpanded;
  public showCountry;
  public showNaPlan;
  public showCmp;
  public isMobile;
  constructor(private saleService: SaleService, private deviceService: DeviceDetectorService) { }

  ngOnInit() {
    //console.log(this.dataList);
    this.dateList = [];
    this.countryList = [];
    this.tableByCountries = [];

    this.saleService.currentSaleParameters.subscribe( data => {
      if(this.dataIndex === 0 || this.dataIndex === 3) {
        this.shouldBeExpanded = true;
      } else {
        this.shouldBeExpanded = data.chxb_razprto;
      }

      this.showCountry = data.chxb_prikaziDrzave;
      this.showCmp = data.chxb_prikaziProcent;
      this.showNaPlan = data.chxb_prikaziProcentNaPlan;

      //console.log(this.showNaPlan + ' to je na plan');
      if(this.dataList){
        if(this.saleType != 'SALE_HOUR_01') {
          //this.dateFormatter();
        }
        this.extractCountries();
        this.extractDates();
        this.sortByDate();
      }
    });
    this.isMobile = this.deviceService.isMobile();
    if(!this.isMobile) {
      if(this.showNaPlan && this.showCmp) {
        this.displayedColumns = ['title', 'saleVal', 'plan', 'calculate'];
      } else if (this.showNaPlan) {
        this.displayedColumns = ['title', 'saleVal', 'plan'];
      } else if (this.showCmp) {
        this.displayedColumns = ['title', 'saleVal', 'calculate'];
      } else {
        this.displayedColumns = ['title', 'saleVal'];
      }
    } else {
      if(this.showNaPlan && this.showCmp && this.saleType === 'SALE_DATE_PART_01') {
        this.displayedColumns = ['title', 'saleVal', 'plan', 'calculate'];
      } else if (this.showNaPlan && this.saleType === 'SALE_DATE_PART_01') {
        this.displayedColumns = ['title', 'saleVal', 'plan'];
      } else if (this.showCmp) {
        this.showNaPlan = false;
        this.displayedColumns = ['title', 'saleVal', 'calculate'];
      } else {
        this.showNaPlan = false;
        this.showCmp = false;
        this.displayedColumns = ['title', 'saleVal'];
      }
    }

  }

  ngOnChanges(changes: SimpleChanges){
    //console.log(changes)
    if(changes.dataList){
      //console.log(changes.dataList);
      this.ngOnInit();
    }
  }
  roundingToolNoDecimal(num) {
    return Math.round(num);
  }
  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}

dateSum(dateIndex) {
  let sum = 0;
  for(let i = 0; i < this.tableByCountries[dateIndex].length; i++){
    for(let j = 0; j < this.tableByCountries[dateIndex][i].length; j++){
      if (this.saleFilter === 'SALEVALUE') {
        sum += this.tableByCountries[dateIndex][i][j].saleVal;
      } else if (this.saleFilter === 'MARGINPERCENT') {
        sum += this.tableByCountries[dateIndex][i][j].marginPrc;
      } else if (this.saleFilter === 'SALEVALUEWT') {
        sum += this.tableByCountries[dateIndex][i][j].saleValWT;
      } else if (this.saleFilter === 'QUANTITY') {
        sum += this.tableByCountries[dateIndex][i][j].quantity;
      } else if (this.saleFilter === 'DOCUMENTCOUNT') {
        sum += this.tableByCountries[dateIndex][i][j].docCount;
      } else if (this.saleFilter === 'ITEMCOUNT') {
        sum += this.tableByCountries[dateIndex][i][j].itemCount;
      }
    }
  }
  return sum;
}

dateCalcCmp(dateIndex, valueType) {
  let sumSaleVal = this.dateSum(dateIndex);
  let sumCmp = this.dateSumCmp(dateIndex, valueType);
  if (sumCmp == 0) {
    return 0;
  } else {
    return (sumSaleVal / sumCmp ) * 100;
  }
}

dateSumCmp(dateIndex, valueType) {
  let sum = 0;
  for(let i = 0; i < this.tableByCountries[dateIndex].length; i++){
    for(let j = 0; j < this.tableByCountries[dateIndex][i].length; j++){
      if(this.saleFilter === 'SALEVALUE') {
        if(valueType != 'cmp') {
          sum += this.tableByCountries[dateIndex][i][j].saleValPlan;
        } else {
          sum += this.tableByCountries[dateIndex][i][j].saleValCmp;
        }
    } else if(this.saleFilter === 'MARGINPERCENT') {
      if(valueType != 'cmp') {
        sum += this.tableByCountries[dateIndex][i][j].marginValPlan;
      } else {
        sum += this.tableByCountries[dateIndex][i][j].marginPrcCmp;
      }
    } else if (this.saleFilter === 'SALEVALUEWT') {
      if(valueType != 'cmp') {
        sum += this.tableByCountries[dateIndex][i][j].saleValWTPlan;
      } else {
        sum += this.tableByCountries[dateIndex][i][j].saleValWTCmp;
      }
    } else if (this.saleFilter === 'QUANTITY') {
      sum += this.tableByCountries[dateIndex][i][j].quantityCmp;
    } else if (this.saleFilter === 'DOCUMENTCOUNT') {
      sum += this.tableByCountries[dateIndex][i][j].docCountCmp;
    } else if (this.saleFilter === 'ITEMCOUNT') {
      sum += this.tableByCountries[dateIndex][i][j].itemCountCmp;
    }
    }
  }
  return sum;
}

nullPointer(dateIndex, countryIndex) {

  if (this.tableByCountries[dateIndex][countryIndex].length > 0) {
    return true;
  } else {
    return false;
  }
}

spliceCountry(country: string) {
  if(country.length > 30) {
    return country.substring(0, 30) + '...';
  } else {
    return country;
  }
}

countryCalcCmp(dateIndex, countryIndex, valueType) {
  let sumSaleVal = this.countrySum(dateIndex, countryIndex);
  let sumCmp = this.countryCmpForColoring(dateIndex, countryIndex, valueType);


  if (sumCmp == 0) {
    return 0;
  } else {
    return (sumSaleVal / sumCmp ) * 100;
  }
}
countrySum(dateIndex, countryIndex)  {
  let sum = 0;
  for(let i = 0; i < this.tableByCountries[dateIndex][countryIndex].length; i++){
    if(this.saleFilter === 'SALEVALUE') {
      sum += this.tableByCountries[dateIndex][countryIndex][i].saleVal;
    } else if (this.saleFilter === 'MARGINPERCENT') {
      sum += this.tableByCountries[dateIndex][countryIndex][i].marginPrc;
    } else if (this.saleFilter === 'SALEVALUEWT') {
      sum += this.tableByCountries[dateIndex][countryIndex][i].saleValWT;
    } else if (this.saleFilter === 'QUANTITY') {
      sum += this.tableByCountries[dateIndex][countryIndex][i].quantity;
    } else if (this.saleFilter === 'DOCUMENTCOUNT') {
      sum += this.tableByCountries[dateIndex][countryIndex][i].docCount;
    } else if (this.saleFilter === 'ITEMCOUNT') {
      sum += this.tableByCountries[dateIndex][countryIndex][i].itemCount;
    }
  }
  return sum;
}

countryCmpForColoring(dateIndex, countryIndex, valueType) {
  let sumCmp = 0;
  for(let i = 0; i < this.tableByCountries[dateIndex][countryIndex].length; i++){
    if(this.saleFilter === 'SALEVALUE') {
      if(valueType != 'cmp') {
        sumCmp += this.tableByCountries[dateIndex][countryIndex][i].saleValPlan;
      } else {
        sumCmp += this.tableByCountries[dateIndex][countryIndex][i].saleValCmp;
      }
    } else if (this.saleFilter === 'MARGINPERCENT'){
      if(valueType != 'cmp') {
        sumCmp += this.tableByCountries[dateIndex][countryIndex][i].marginValPlan;
      } else {
        sumCmp += this.tableByCountries[dateIndex][countryIndex][i].marginPrcCmp;
      }
    } else if (this.saleFilter === 'SALEVALUEWT') {
      if(valueType != 'cmp') {
        sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].saleValWTPlan;
      } else {
        sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].saleValWT;
      }
    } else if (this.saleFilter === 'QUANTITY') {
      sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].quantityCmp;
    } else if (this.saleFilter === 'DOCUMENTCOUNT') {
      sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].docCountCmp;
    } else if (this.saleFilter === 'ITEMCOUNT') {
      sumCmp +=  this.tableByCountries[dateIndex][countryIndex][i].itemCountCmp;
    }
  }
  return sumCmp;
}

calculateSaleVal(element: Sale) {
  if(this.saleFilter === 'SALEVALUE'){
    if (element.saleValCmp == 0) {
      return 0;
    } else {
      return (element.saleVal / element.saleValCmp) * 100;
    }
  } else if (this.saleFilter === 'MARGINPERCENT') {
    if (element.marginPrcCmp == 0) {
      return 0;
    } else {
      return (element.marginPrc / element.marginPrcCmp) * 100;
    }
  } else if (this.saleFilter === 'SALEVALUEWT') {
    if (element.saleValWTCmp == 0) {
      return 0;
    } else {
      return (element.saleValWT / element.saleValWTCmp) * 100;
    }
  } else if (this.saleFilter === 'QUANTITY') {
    if (element.quantityCmp == 0) {
      return 0;
    } else {
      return (element.quantity / element.quantityCmp) * 100;
    }
  } else if (this.saleFilter === 'DOCUMENTCOUNT') {
    if (element.docCountCmp == 0) {
      return 0;
    } else {
      return (element.docCount / element.docCountCmp) * 100;
    }
  } else if (this.saleFilter === 'ITEMCOUNT') {
    if (element.itemCountCmp == 0) {
      return 0;
    } else {
      return (element.itemCount / element.itemCountCmp) * 100;
    }
  }
}

calculatePlan(element: Sale) {
  if(this.saleFilter === 'SALEVALUE'){
    if (element.saleValPlan == 0 || element.saleValPlan == null) {
      return 0;
    } else {
      return (element.saleVal / element.saleValPlan) * 100;
    }
  } else if (this.saleFilter === 'MARGINPERCENT') {
    if (element.marginValPlan == 0 || element.saleValPlan == null) {
      return 0;
    } else {
      return (element.marginPrc / element.marginValPlan) * 100;
    }
  } else if (this.saleFilter === 'SALEVALUEWT') {
    if (element.saleValWTPlan == 0 || element.saleValPlan == null) {
      return 0;
    } else {
      return (element.saleValWT / element.saleValWTPlan) * 100;
    }
  }
}

showValue(num: Sale) {
  if(this.saleFilter === 'SALEVALUE') {
    return Math.round(num.saleVal);
  } else if(this.saleFilter === 'MARGINPERCENT') {
    return Math.round(num.marginPrc);
  } else if (this.saleFilter === 'SALEVALUEWT') {
    return Math.round(num.saleValWT);
  } else if (this.saleFilter === 'QUANTITY') {
    return Math.round(num.quantity);
  } else if (this.saleFilter === 'DOCUMENTCOUNT') {
    return Math.round(num.docCount);
  } else if (this.saleFilter === 'ITEMCOUNT') {
    return Math.round(num.itemCount);
  }
}

extractDates() {
  for(let i = 0; i < this.dataList.length; i ++) {

    if (!this.dateList.includes(this.dataList[i].date.toString())) {
      this.dateList.push(this.dataList[i].date);
    }
  }
}


dateFormatter() {
  for(let i = 0; i < this.dataList.length; i ++) {
    this.dataList[i].date = moment(this.dataList[i].date).format("DD.MM.YYYY");
  }
}

extractCountries() {
  for(let i = 0; i < this.dataList.length; i ++) {
    if (!this.countryList.includes(this.dataList[i].country.toString())) {
      this.countryList.push(this.dataList[i].country);
    }
  }
}
  sortByDate() {
    for(let i = 0; i < this.dateList.length; i++) {
      this.tableByCountries[i] = [];
      for(let j = 0; j < this.countryList.length; j++) {
        this.tableByCountries[i][j] = [];
        for(let k = 0; k < this.dataList.length; k++) {
          if(this.dateList[i] === this.dataList[k].date && this.countryList[j] === this.dataList[k].country) {
            this.tableByCountries[i][j].push(this.dataList[k]);
          }
        }
      }
    }
  }
}

